import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Bonus4() {
  const benefits = ['Step-by-step worksheet (beginner-friendly, no formulas to figure out)', 'The "Monthly Bleed" formula: what the house costs you every month you wait', 'SELL scenario: estimated net after costs, debts, repairs, and holding time', 'RENT scenario: realistic cash flow + break-even timeline', 'HOLD scenario: total cost of waiting 3 / 6 / 12 months', '3 pre-filled worked examples (sell wins / rent works / hold temporarily)', 'A family-ready 1-page Decision Summary to present with confidence', 'The "Family Fight Prevention" script to de-escalate disagreements with data'];
  return <section className="bg-warm-white py-12 md:py-20 px-6 border-b border-gold/20" data-id="element-68">
      <div className="max-w-6xl mx-auto" data-id="element-69">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-12 items-center" data-id="element-70">
          <div className="w-full lg:w-1/3 flex justify-center" data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/gkrC9ZRkN4swRB59rKFcfx/Bonus_4_image_The_Inherited_House.png" alt="The Sell vs. Rent vs. Hold Decision Calculator" className="w-full max-w-sm object-contain drop-shadow-editorial rounded-lg" data-id="element-72" />
          </div>

          <div className="w-full lg:w-2/3" data-id="element-73">
            <div className="inline-block bg-amber-100 text-amber-800 font-bold px-4 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-74">
              BONUS #4
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-2" data-id="element-75">
              The Sell vs. Rent vs. Hold Decision Calculator
            </h2>
            <h3 className="text-xl md:text-2xl text-navy-light font-heading italic mb-2" data-id="element-76">
              "Decide in 20 Minutes (Without Family Fights)"
            </h3>
            <p className="text-lg text-slate font-medium mb-8" data-id="element-77">
              Value: $9.99 — Yours FREE Today
            </p>

            <div className="space-y-4 text-text-dark font-body text-lg leading-relaxed mb-8" data-id="element-78">
              <p data-id="element-79">
                Every inherited house eventually comes down to one question:
              </p>
              <p className="font-bold text-navy" data-id="element-80">What do we do with it?</p>
              <p data-id="element-81">
                And that question — without numbers — turns into arguments.
                Everyone has an opinion. Nobody has a plan.
              </p>
              <p data-id="element-82">This calculator changes that in 20 minutes.</p>
              <p data-id="element-83">
                You fill in 6 basic numbers. It shows you the realistic monthly
                bleed, the estimated net from selling, the cash flow from
                renting, and the true cost of waiting. Then it generates a
                1-page decision summary you can share with the family — so
                you're arguing from math, not emotion.
              </p>
            </div>

            <h4 className="text-xl font-bold text-navy mb-4" data-id="element-84">
              Here's what's inside:
            </h4>
            <ul className="space-y-3 mb-8" data-id="element-85">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-86">
                  <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-87" />
                  <span className="text-text-dark text-lg" data-id="element-88">{benefit}</span>
                </li>)}
            </ul>

            <div className="bg-white p-6 rounded-xl border border-slate-light/20 shadow-sm space-y-4" data-id="element-89">
              <p className="text-text-dark font-body" data-id="element-90">
                <strong className="text-navy" data-id="element-91">Who this is for:</strong> Any heir
                or executor who's stuck in "we can't agree" mode.
              </p>
              <p className="text-text-dark font-body" data-id="element-92">
                <strong className="text-navy" data-id="element-93">What it replaces:</strong> A $500
                consultation with a real estate professional — for $0.
              </p>
              <blockquote className="border-l-4 border-gold pl-4 italic text-slate mt-4" data-id="element-94">
                "We had been going back and forth for 3 months. I filled this
                out in 20 minutes. We made the decision that day." — Verified
                reader
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>;
}